// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agreement-overview,
.agreement-clauses {
  display: grid;
  gap: var(--space-5);
  min-width: 0;
}
.agreement-overview-status {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  flex-wrap: wrap;
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
}
.agreement-overview-columns {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);
  gap: var(--space-6);
  align-items: start;
}
.agreement-facts {
  display: grid;
  grid-template-columns: minmax(100px, 1fr) minmax(0, 3fr);
  gap: var(--space-4);
  margin: 0;
  font-size: var(--font-size-body-sm);
}
.agreement-facts dt {
  color: var(--text-secondary);
}
.agreement-facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}
.agreement-signature-records {
  display: grid;
  gap: var(--space-5);
}
.agreement-signature-records > div {
  display: grid;
  gap: var(--space-3);
  border-top: 1px solid var(--border-subtle);
  padding-top: var(--space-4);
}
.agreement-signature-records img {
  max-height: 90px;
  width: 100%;
  object-fit: contain;
  object-position: left;
  background: var(--surface-primary);
}
.agreement-saved-terms h3 {
  margin: 0 0 var(--space-4);
  color: var(--interactive-default);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
}
.agreement-verification-parties {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-5);
}
.agreement-email-preview {
  display: grid;
  gap: var(--space-4);
  background: var(--surface-secondary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  padding: var(--space-5);
}
.agreement-review-state {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  justify-content: space-between;
  flex-wrap: wrap;
}
.rcti-agreements .rcti-agreements__content.agreement-journey-page {
  padding: var(--space-8);
}
.agreement-journey-page > .rcti-design-heading .rcti-design-breadcrumb {
  display: none;
}
.agreement-journey-page .rcti-design-columns {
  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);
}
.agreement-invitation-fields {
  display: grid;
  gap: var(--space-4);
}
.agreement-invitation-fields p {
  white-space: pre-wrap;
}
.rcti-invitation-closed {
  min-height: 60vh;
  display: grid;
  align-content: center;
  justify-items: center;
  gap: var(--space-5);
  padding: var(--space-8);
  text-align: center;
}
@media (max-width: 900px) {
  .agreement-overview-columns {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .agreement-verification-parties {
    grid-template-columns: 1fr;
  }
  .agreement-facts {
    grid-template-columns: 1fr;
    gap: var(--space-2);
  }
  .agreement-facts dd + dt {
    margin-top: var(--space-3);
  }
  .rcti-agreements .rcti-agreements__content.agreement-journey-page {
    padding: var(--space-5) var(--space-4);
  }
}

.rcti-public-workspace.is-signed-overview {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}
.rcti-public-workspace.is-signed-overview > .agreement-overview {
  width: 100%;
}
.rcti-agreements--public .rcti-agreements__content {
  width: 100%;
}
.rcti-agreements--public .rcti-agreement-card form label:not(.rcti-consent) {
  display: grid;
  gap: var(--space-2);
}
.agreement-overview .rcti-agreements__actions {
  display: grid;
  justify-items: start;
}
.agreement-linked-rctis {
  display: grid;
  gap: var(--space-4);
  list-style: none;
  padding: 0;
  margin: 0;
}
.agreement-linked-rctis li {
  display: grid;
  gap: var(--space-2);
  border-bottom: 1px solid var(--border-subtle);
  padding-bottom: var(--space-4);
}
.agreement-contact-summary {
  display: grid;
  gap: var(--space-4);
  border-top: 1px solid var(--border-subtle);
  padding-top: var(--space-5);
}
.agreement-verification {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);
  gap: var(--space-6);
  align-items: start;
}
.agreement-verification > .agreement-verification-parties,
.agreement-verification > footer {
  grid-column: 1/-1;
}
.agreement-verification-parties .agreement-facts {
  grid-template-columns: 1fr 1.7fr;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  padding: var(--space-4);
}
.agreement-verification-parties .agreement-facts dd {
  text-align: right;
}
.agreement-verification-parties .agreement-facts :is(dt, dd) {
  padding-bottom: var(--space-3);
  border-bottom: 1px solid var(--border-subtle);
}
@media (max-width: 760px) {
  .agreement-verification {
    grid-template-columns: 1fr;
  }
  .agreement-verification-parties .agreement-facts {
    grid-template-columns: 1fr;
  }
  .agreement-verification-parties .agreement-facts dd {
    text-align: left;
  }
}
.agreement-clauses--structured {
  gap: var(--space-5);
}
.agreement-clauses--structured .agreement-clause {
  display: grid;
  gap: var(--space-2);
}
.rcti-designed .agreement-clauses--structured .agreement-clause h3 {
  margin: 0;
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
  line-height: 1.5;
}
.rcti-designed .agreement-clauses--structured .agreement-clause p {
  margin: 0;
  color: var(--text-primary);
  font-size: var(--font-size-body-sm);
  line-height: 1.65;
}
/* C09 management stays within the detail; status drives the main action. */
.agreement-overview-primary {
  margin-left: auto;
}
.agreement-management-menu summary {
  cursor: pointer;
  color: var(--interactive-default);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
  padding: var(--space-3) 0;
}
.agreement-management-menu[open] summary {
  margin-bottom: var(--space-3);
}
.agreement-management-menu .rcti-agreements__actions {
  display: grid;
  justify-items: stretch;
}
.agreement-delivery-record {
  border-top: 1px solid var(--border-subtle);
  margin-top: var(--space-4);
  padding-top: var(--space-4);
}
.rcti-agreements .rcti-saved-signature img {
  background: transparent;
  mix-blend-mode: multiply;
}
[data-theme="dark"] .rcti-agreements .rcti-saved-signature img {
  filter: invert(1);
  mix-blend-mode: screen;
}
@media (max-width: 600px) {
  .agreement-overview-primary {
    margin-left: 0;
  }
}
.agreement-overview-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-4);
  padding-top: var(--space-5);
  border-top: 1px solid var(--border-subtle);
}
.agreement-overview .rcti-agreement-card > h2 {
  font-size: var(--font-size-body-lg);
  font-weight: var(--font-weight-medium);
}
.agreement-overview .rcti-design-party-grid small {
  text-transform: uppercase;
  font-size: var(--font-size-caption-md);
  font-weight: var(--font-weight-medium);
}
.agreement-overview .rcti-design-timeline {
  list-style: none;
  padding: 0;
  margin: 0;
}
.agreement-overview--supplier .agreement-signature-records {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.agreement-overview--supplier .agreement-signature-records > div {
  min-width: 0;
  overflow-wrap: anywhere;
}
@media (max-width: 600px) {
  .agreement-overview--supplier .agreement-signature-records {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media print {
  .rcti-agreements--public .agreement-overview-status,
  .rcti-agreements--public .rcti-design-sidebar,
  .rcti-agreements--public .agreement-overview-footer {
    display: none !important;
  }
  .rcti-agreements--public .agreement-overview-columns {
    display: block;
  }
  .rcti-agreements--public .agreement-saved-terms > .agreement-clauses {
    display: block;
  }
}
.rcti-supplier-page .agreement-overview p { font-size: var(--font-size-body-sm); line-height: 1.65; }
.agreement-overview--supplier .agreement-signature-records > div { grid-template-rows: auto auto auto 1fr auto; }
.agreement-overview--supplier .rcti-saved-signature img { height: 100px; object-fit: contain; }
@supports (grid-template-rows:subgrid) { .agreement-overview--supplier .agreement-signature-records > div { grid-row: span 5; grid-template-rows: subgrid; } }
@media (max-width:600px) { .agreement-overview--supplier .agreement-signature-records > div { grid-row: auto; grid-template-rows: auto; } }
.agreement-management-menu .rcti-agreements__actions > button {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  justify-content: center;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/agreementJourney.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,wDAAwD;EACxD,mBAAmB;EACnB,SAAS;EACT,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,mCAAmC;EACnC,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,0BAA0B;EAC1B,mCAAmC;EACnC,iBAAiB;AACnB;AACA,2EAA2E;AAC3E;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,mCAAmC;EACnC,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,gDAAgD;AAClD;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;;;IAGE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;AACA,4CAA4C,mCAAmC,EAAE,iBAAiB,EAAE;AACpG,mEAAmE,2CAA2C,EAAE;AAChH,0DAA0D,aAAa,EAAE,mBAAmB,EAAE;AAC9F,yCAAyC,mEAAmE,gBAAgB,EAAE,2BAA2B,EAAE,EAAE;AAC7J,2BAA2B,mEAAmE,cAAc,EAAE,wBAAwB,EAAE,EAAE;AAC1I;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB","sourcesContent":[".agreement-overview,\n.agreement-clauses {\n  display: grid;\n  gap: var(--space-5);\n  min-width: 0;\n}\n.agreement-overview-status {\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n  flex-wrap: wrap;\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n}\n.agreement-overview-columns {\n  display: grid;\n  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);\n  gap: var(--space-6);\n  align-items: start;\n}\n.agreement-facts {\n  display: grid;\n  grid-template-columns: minmax(100px, 1fr) minmax(0, 3fr);\n  gap: var(--space-4);\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n}\n.agreement-facts dt {\n  color: var(--text-secondary);\n}\n.agreement-facts dd {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n.agreement-signature-records {\n  display: grid;\n  gap: var(--space-5);\n}\n.agreement-signature-records > div {\n  display: grid;\n  gap: var(--space-3);\n  border-top: 1px solid var(--border-subtle);\n  padding-top: var(--space-4);\n}\n.agreement-signature-records img {\n  max-height: 90px;\n  width: 100%;\n  object-fit: contain;\n  object-position: left;\n  background: var(--surface-primary);\n}\n.agreement-saved-terms h3 {\n  margin: 0 0 var(--space-4);\n  color: var(--interactive-default);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-verification-parties {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-5);\n}\n.agreement-email-preview {\n  display: grid;\n  gap: var(--space-4);\n  background: var(--surface-secondary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  padding: var(--space-5);\n}\n.agreement-review-state {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.rcti-agreements .rcti-agreements__content.agreement-journey-page {\n  padding: var(--space-8);\n}\n.agreement-journey-page > .rcti-design-heading .rcti-design-breadcrumb {\n  display: none;\n}\n.agreement-journey-page .rcti-design-columns {\n  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);\n}\n.agreement-invitation-fields {\n  display: grid;\n  gap: var(--space-4);\n}\n.agreement-invitation-fields p {\n  white-space: pre-wrap;\n}\n.rcti-invitation-closed {\n  min-height: 60vh;\n  display: grid;\n  align-content: center;\n  justify-items: center;\n  gap: var(--space-5);\n  padding: var(--space-8);\n  text-align: center;\n}\n@media (max-width: 900px) {\n  .agreement-overview-columns {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 600px) {\n  .agreement-verification-parties {\n    grid-template-columns: 1fr;\n  }\n  .agreement-facts {\n    grid-template-columns: 1fr;\n    gap: var(--space-2);\n  }\n  .agreement-facts dd + dt {\n    margin-top: var(--space-3);\n  }\n  .rcti-agreements .rcti-agreements__content.agreement-journey-page {\n    padding: var(--space-5) var(--space-4);\n  }\n}\n\n.rcti-public-workspace.is-signed-overview {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n}\n.rcti-public-workspace.is-signed-overview > .agreement-overview {\n  width: 100%;\n}\n.rcti-agreements--public .rcti-agreements__content {\n  width: 100%;\n}\n.rcti-agreements--public .rcti-agreement-card form label:not(.rcti-consent) {\n  display: grid;\n  gap: var(--space-2);\n}\n.agreement-overview .rcti-agreements__actions {\n  display: grid;\n  justify-items: start;\n}\n.agreement-linked-rctis {\n  display: grid;\n  gap: var(--space-4);\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.agreement-linked-rctis li {\n  display: grid;\n  gap: var(--space-2);\n  border-bottom: 1px solid var(--border-subtle);\n  padding-bottom: var(--space-4);\n}\n.agreement-contact-summary {\n  display: grid;\n  gap: var(--space-4);\n  border-top: 1px solid var(--border-subtle);\n  padding-top: var(--space-5);\n}\n.agreement-verification {\n  display: grid;\n  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);\n  gap: var(--space-6);\n  align-items: start;\n}\n.agreement-verification > .agreement-verification-parties,\n.agreement-verification > footer {\n  grid-column: 1/-1;\n}\n.agreement-verification-parties .agreement-facts {\n  grid-template-columns: 1fr 1.7fr;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  padding: var(--space-4);\n}\n.agreement-verification-parties .agreement-facts dd {\n  text-align: right;\n}\n.agreement-verification-parties .agreement-facts :is(dt, dd) {\n  padding-bottom: var(--space-3);\n  border-bottom: 1px solid var(--border-subtle);\n}\n@media (max-width: 760px) {\n  .agreement-verification {\n    grid-template-columns: 1fr;\n  }\n  .agreement-verification-parties .agreement-facts {\n    grid-template-columns: 1fr;\n  }\n  .agreement-verification-parties .agreement-facts dd {\n    text-align: left;\n  }\n}\n.agreement-clauses--structured {\n  gap: var(--space-5);\n}\n.agreement-clauses--structured .agreement-clause {\n  display: grid;\n  gap: var(--space-2);\n}\n.rcti-designed .agreement-clauses--structured .agreement-clause h3 {\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.5;\n}\n.rcti-designed .agreement-clauses--structured .agreement-clause p {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: var(--font-size-body-sm);\n  line-height: 1.65;\n}\n/* C09 management stays within the detail; status drives the main action. */\n.agreement-overview-primary {\n  margin-left: auto;\n}\n.agreement-management-menu summary {\n  cursor: pointer;\n  color: var(--interactive-default);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n  padding: var(--space-3) 0;\n}\n.agreement-management-menu[open] summary {\n  margin-bottom: var(--space-3);\n}\n.agreement-management-menu .rcti-agreements__actions {\n  display: grid;\n  justify-items: stretch;\n}\n.agreement-delivery-record {\n  border-top: 1px solid var(--border-subtle);\n  margin-top: var(--space-4);\n  padding-top: var(--space-4);\n}\n.rcti-agreements .rcti-saved-signature img {\n  background: transparent;\n  mix-blend-mode: multiply;\n}\n[data-theme=\"dark\"] .rcti-agreements .rcti-saved-signature img {\n  filter: invert(1);\n  mix-blend-mode: screen;\n}\n@media (max-width: 600px) {\n  .agreement-overview-primary {\n    margin-left: 0;\n  }\n}\n.agreement-overview-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--border-subtle);\n}\n.agreement-overview .rcti-agreement-card > h2 {\n  font-size: var(--font-size-body-lg);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-overview .rcti-design-party-grid small {\n  text-transform: uppercase;\n  font-size: var(--font-size-caption-md);\n  font-weight: var(--font-weight-medium);\n}\n.agreement-overview .rcti-design-timeline {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.agreement-overview--supplier .agreement-signature-records {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.agreement-overview--supplier .agreement-signature-records > div {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n@media (max-width: 600px) {\n  .agreement-overview--supplier .agreement-signature-records {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media print {\n  .rcti-agreements--public .agreement-overview-status,\n  .rcti-agreements--public .rcti-design-sidebar,\n  .rcti-agreements--public .agreement-overview-footer {\n    display: none !important;\n  }\n  .rcti-agreements--public .agreement-overview-columns {\n    display: block;\n  }\n  .rcti-agreements--public .agreement-saved-terms > .agreement-clauses {\n    display: block;\n  }\n}\n.rcti-supplier-page .agreement-overview p { font-size: var(--font-size-body-sm); line-height: 1.65; }\n.agreement-overview--supplier .agreement-signature-records > div { grid-template-rows: auto auto auto 1fr auto; }\n.agreement-overview--supplier .rcti-saved-signature img { height: 100px; object-fit: contain; }\n@supports (grid-template-rows:subgrid) { .agreement-overview--supplier .agreement-signature-records > div { grid-row: span 5; grid-template-rows: subgrid; } }\n@media (max-width:600px) { .agreement-overview--supplier .agreement-signature-records > div { grid-row: auto; grid-template-rows: auto; } }\n.agreement-management-menu .rcti-agreements__actions > button {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  justify-content: center;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
